module.exports = __webpack_public_path__ + "static/media/lunamoth.ba490b15.png";